module.exports = __webpack_public_path__ + "awaiting-arrival.png?fa7bef1f82e6ec6d99afde309984f306";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/awaiting-arrival.png
// module id = 478
// module chunks = 0